import { motion } from "framer-motion";
import styled from "styled-components";

export const ActiveLineStyle = styled.div`
  height: 0.25rem;
  position: absolute;
  top: 1.5rem;
  background-color: lightblue;
  width: 100%;
`;

export const MotionActiveLineStyle = motion.create(ActiveLineStyle);
